import { ref } from 'vue';
import { useResendTimer } from '@/composables/useResendTimer';

export function usePhoneVerification() {
  const codeError = ref(false);

  const {
    timerBeforeResend,
    canResend,
    isResending,
    startTimer,
    resetTimer,
    handleResend,
  } = useResendTimer();

  const clearError = () => {
    codeError.value = false;
  };

  const resendCode = async (sendFn: () => Promise<void>) => {
    await handleResend(sendFn);
  };

  const verifyCode = async (validateFn: () => Promise<boolean>) => {
    clearError();

    try {
      const isValid = await validateFn();
      if (isValid) {
        resetTimer();
        return true;
      }

      codeError.value = true;
      return false;
    } catch (error) {
      codeError.value = true;
      return false;
    }
  };

  return {
    codeError,
    timerBeforeResend,
    canResend,
    isResending,
    startTimer,
    resetTimer,
    resendCode,
    verifyCode,
    clearError,
  };
}
